import { render, staticRenderFns } from "./RentCreateUpdate.vue?vue&type=template&id=65a4778c&"
import script from "./RentCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./RentCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports